<template>
  <div class="project-card-status" :class="[status]">
    <div class="project-card-status-text">{{$t('status_'+status)}}</div>
  </div>
</template>

<script>
export default {
  name: 'ProjectCardStatus',
  props: ['status']
}
</script>

<style lang="stylus" scoped>
.project-card-status
  align-items: center
  border-radius: 10px
  display: flex
  height: 20px
  justify-content: center
  margin-left: auto
  width: 60px

  &.ongoing
    background-color: rgba($project-ongoing, 0.2)
    color: $project-ongoing

  &.draft
    background-color: rgba($project-draft, 0.2)
    color: $project-draft

  &.closed
    background-color: rgba($project-closed, 0.2)
    color: $project-closed
  
  &.archived
    background-color: rgba($project-archived, 0.2)
    color: #fff


  .project-card-status-text
    m-first-letter-case()
    m-font-size(11, 13)
</style>